import BulletIcon from "../../assets/product-list-assets/bullet.svg";
import type { ProductListGroup } from "../../types";

export const bullet: ProductListGroup = {
  id: "bullet",
  title: "bullet.title",
  icon: {
    src: BulletIcon,
    width: 24,
    height: 21,
  },
};
